module.exports = __webpack_public_path__ + "static/media/TITAN Buyer Manual_Oct-2020_vf.1e7469e1.pdf";